import { ChangeDetectorRef, Component, ElementRef, Renderer2, ViewContainerRef } from '@angular/core';
import { NewPlanForm } from "sharedFeatures/newplan-win";
import { WindowComponent } from 'sharedFeatures/window';
import { SetupWarningPopupBody } from './setup-warning-popup-body.component';

@Component({
    selector: 'setup-warning-popup',
    templateUrl: '../../window/window.component.html',
    styleUrls: ['../../window/window.component.less']
})
export class SetupWarningPopup extends WindowComponent {

    title = $localize`ARE_YOU_SURE_YOU_WANT_TO`;
    width = 451;
    height = 232;

    windowContentBody = SetupWarningPopupBody;

    modal = true;

    topMargin = 40;

    showClose = true;

    constructor(element: ElementRef,
                r: Renderer2,
                viewContainerRef: ViewContainerRef,
                chDet: ChangeDetectorRef) {

        super(element, r, viewContainerRef, chDet);

    }

    async close() {
        
        await super.close();
        (<NewPlanForm>this.getOwner()).getElDom().focus();

    }
}